export const DEFAULT_FONT =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';

export const fonts: Record<string, string> = {
  heading: `"MM Sans", ${DEFAULT_FONT}`,
  body: `"Geist", ${DEFAULT_FONT}`,
  code: `SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier, monospace`,
};
